export const RESEARCH_MODE_OPTIONS = [
  {
    value: "none",
    label: "No Research",
    description: "No web lookup. The agent uses your prompt, brand, selected skills, uploaded files, pasted URLs, and source notes.",
  },
  {
    value: "sources_only",
    label: "Quick Web Scan",
    description: "Runs a fast web search and uses result titles, links, and snippets. Uploaded files and source notes still apply.",
  },
  {
    value: "deep",
    label: "Thorough Research",
    description: "Searches the web and reads selected full pages before drafting. Uploaded files and source notes still apply.",
  },
];

const RESEARCH_MODE_MAP = Object.fromEntries(RESEARCH_MODE_OPTIONS.map((option) => [option.value, option]));

export function getResearchModeOption(mode) {
  return RESEARCH_MODE_MAP[mode] || RESEARCH_MODE_MAP.none;
}

export function formatResearchMode(mode) {
  return getResearchModeOption(mode).label;
}

export function describeResearchMode(mode) {
  return getResearchModeOption(mode).description;
}
